import ReduxStore from '../../../ReduxStore';
import AnalyticsGateway from 'lib/AnalyticsGateway';
import {getIn} from 'lib/immutableObject';
import {findSection} from 'ducks/reportSections';
import {trackComparableSalesProperties} from 'api/reports/tracking/TrackableComparableSalesProperties';
import CoverImages from 'lib/CoverImages';
import {hasSelectedNotes} from 'api/reports/util/NotesUtils';
import {countFeaturedComparables} from 'api/reports/tracking/FeaturedComparablesTrackingUtils';
import {getTrackableSectionNames} from 'api/reports/tracking/GetTrackableSectionNames';
import {trackSectionsTitlesProperties} from 'api/reports/tracking/TrackableSectionsTitlesProperties';
import {trackCoverPageProperties} from 'api/reports/tracking/TrackableCoverPageProperties';
import {trackTestimonialsProperties} from 'api/reports/tracking/TrackableTestimonialsProperties';
import get from 'lodash/get';
import {trackComparableListingProperties} from 'api/reports/tracking/TrackableComparableListingProperties';
import {trackSummaryProperties} from 'api/reports/tracking/TrackableSummaryProperties';
import {trackPhotoCountsProperties} from 'api/reports/tracking/TrackablePhotoCountsProperties';
import format from 'dateformat';

export const trackReport = (reportType, payload, reportSections, reportUrl) => {
  const state = ReduxStore.getState();
  const {
    propertyDetail: {
      councilAreaName,
      localityName,
      propertyId,
      propertyType,
      singleLineAddress,
      postcode,
      state: propertyState = 'N/A'
    },
    userDetails: {username},
    theme,
    comparableSales,
    comparableListings,
  } = state;

  const reportDescription = AnalyticsGateway.reportDescription(reportType);

  const targetPropertyProps = propertyState.match(/NZ/i) ? [
    {label: 'Target Property Locality', value: localityName},
    {label: 'Target Property Council Area', value: councilAreaName},
    {label: 'Target Property Category', value: propertyType},
  ] : [
    {label: 'Target Property State', value: propertyState},
    {label: 'Target Property Suburb', value: localityName},
    {label: 'Target Property Type', value: propertyType},
  ];

  const properties = [
    {label: 'Page', value: 'Preview Report'},
    {label: 'Report Format', value: 'PDF'},
    {label: 'Property ID', value: propertyId},
    {label: 'Target Property Address', value: singleLineAddress},
    {label: 'Target Property Postcode', value: postcode},
    {label: 'Report Type', value: reportDescription},
    {label: 'Report PDF', value: reportUrl},
    {
      label: 'Edited Agent Bio',
      value: !!getIn(findSection(reportSections, reportType, 'TARGET_PROPERTY'), ['sectionData', 'agentNotes_isEdited'])
    },
    ...targetPropertyProps,
  ];

  trackComparableSalesProperties(payload, properties, comparableSales);

  if (reportType !== 'soi') {
    const {coverPageImages} = state;
    const selectedImage = CoverImages.selectedImage(state);

    properties.push(...[
      {label: 'Layout', value: selectedImage.type === 'lifestyle' ? 'large' : 'half'},
      {
        label: 'Notes Added to Listings',
        value: comparableListings.selected.filter(id => hasSelectedNotes(id, 'selected.listings')).length
      },
      {label: 'Number of Featured Comparables', value: countFeaturedComparables(comparableListings, comparableSales)},
      {label: 'Report Sections Included', value: getTrackableSectionNames(payload, reportSections, reportType)},
      {label: 'Report Colour', value: theme.colour || 'NOT SET'},
    ]);
    trackSectionsTitlesProperties(payload, properties);
    trackCoverPageProperties(payload, properties, singleLineAddress, selectedImage, coverPageImages);
    trackTestimonialsProperties(payload, properties);
  } else {
    properties.push({label: 'Select CAV SOI', value: get(comparableSales, 'soi.useConsumerAffairsLayout', false)});
  }

  trackComparableListingProperties(payload, properties);
  trackSummaryProperties(payload, properties);
  trackPhotoCountsProperties(comparableSales, comparableListings, properties);

  const isoUtcDateTime = format('isoUtcDateTime');
  AnalyticsGateway.addUserTraits({
    username: username,
    traits: [
      {label: `Date Last Generated ${AnalyticsGateway.reportDescription(reportType)}`, value: isoUtcDateTime},
      {label: 'Date Last Generated Report', value: isoUtcDateTime},
    ]
  });

  AnalyticsGateway.sendEvent({
    eventName: 'Generate Report',
    properties,
  });
};